import { render, staticRenderFns } from "./Barplotly.vue?vue&type=template&id=4e17d492&scoped=true"
import script from "./Barplotly.vue?vue&type=script&lang=js"
export * from "./Barplotly.vue?vue&type=script&lang=js"
import style0 from "./Barplotly.vue?vue&type=style&index=0&id=4e17d492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e17d492",
  null
  
)

export default component.exports